import React, { Fragment } from 'react';
import { generalIcons } from '../icons/materialIcons';
import styled from '@emotion/styled';
import { CustomStyledProps } from 'style/style';
import FavoriteOfferButton from 'atoms/buttons/FavoriteOfferButton';
import breakpoints from 'theme/material/breakpoints';

const OfferActionButtonWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 20,
  [breakpoints.down(639.05)]: {
    'div>*': {
      width: 40,
    },
  },
}));

const OfferIcons = styled('div')(
  {
    display: 'inline-flex',
    marginTop: 10,
  },
  ({ isOfferHighlight }: CustomStyledProps) =>
    isOfferHighlight && {
      svg: {
        width: '64px !important',
        height: '64px !important',
      },
    }
);

interface OfferActionButtonProps {
  offer?: any;
  offerType: any;
  isOfferHighlight: any;
  handleIgnoreOffer: any;
  handleCounter: any;
  counterOfferDisabled: any;
  accountHashId: any;
  handleAcceptOffer: any;
  handleSuggestOffer: any;
  currentUserIsGenerous: any;
  handleCancelOffer: any;
  handleCancelSuggestion: any;
}

const OfferActionButton = ({
  offer,
  offerType,
  isOfferHighlight,
  handleIgnoreOffer,
  handleCounter,
  handleAcceptOffer,
  handleSuggestOffer,
  handleCancelOffer,
  handleCancelSuggestion,
}: OfferActionButtonProps): any => {
  const hasOffer = offer !== undefined && offer.data !== undefined;

  const renderDesktopListViewButtons = (
    isDecline: boolean = true,
    isCounter: boolean = true,
    isSuggestRequest: boolean = false,
    isAccept: boolean = true
  ): JSX.Element => {
    return (
      <OfferActionButtonWrapper>
        {isDecline && (
          <FavoriteOfferButton
            data-test-id="trigger-ignore-offer-highlight"
            hasOffer={hasOffer}
            offer={offer}
            type="decline"
            onClick={handleIgnoreOffer}
            style={{ margin: 0 }}
          />
        )}
        <Fragment>
          {(isCounter || isSuggestRequest) && (
            <FavoriteOfferButton
              data-test-id="trigger-counter-offer-highlight"
              hasOffer={hasOffer}
              offer={offer}
              type="counter"
              onClick={isSuggestRequest ? handleSuggestOffer : handleCounter}
              style={{ margin: 0 }}
            />
          )}
          {isAccept && (
            <FavoriteOfferButton
              data-test-id="trigger-accept-offer-highlight"
              hasOffer={hasOffer}
              offer={offer}
              type="accept"
              label="Accept"
              onClick={handleAcceptOffer}
              style={{ margin: 0 }}
            />
          )}
        </Fragment>
      </OfferActionButtonWrapper>
    );
  };

  switch (offerType) {
    case 'offer_new':
      return <React.Fragment>{renderDesktopListViewButtons()}</React.Fragment>;
    case 'suggestion_new':
      return <React.Fragment>{renderDesktopListViewButtons(true, false, true, false)}</React.Fragment>;
    case 'offer_pending':
      return (
        <React.Fragment>
          <OfferIcons
            id="triggerCancelOfferHighlight"
            data-test-id="trigger-cancel-offer-highlight"
            onClick={handleCancelOffer}
            isOfferHighlight={isOfferHighlight}
          >
            <generalIcons.ignore.cancel />
          </OfferIcons>
        </React.Fragment>
      );
    case 'suggestion_pending':
      return (
        <React.Fragment>
          <OfferIcons
            id="triggerCancelSuggestHighlight"
            data-test-id="trigger-cancel-suggest-highlight"
            onClick={handleCancelSuggestion}
            isOfferHighlight={isOfferHighlight}
          >
            <generalIcons.ignore.cancel />
          </OfferIcons>
        </React.Fragment>
      );

    default:
      return null;
  }
};

export default OfferActionButton;
